(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["offer-banner"] && !Shopify.designMode) return;
  try {
    if (!window.discountPromoBound) {
    window.discountPromoBound = true;

    function fallbackCopy(text, onDone) {
      var ta = document.createElement('textarea');
      ta.value = text;
      ta.setAttribute('readonly', '');
      ta.style.position = 'absolute';
      ta.style.left = '-9999px';
      document.body.appendChild(ta);
      ta.select();
      try {
        if (document.execCommand('copy')) onDone();
      } catch (err) {
        /* copying not supported; leave the hint unchanged */
      }
      document.body.removeChild(ta);
    }

    document.addEventListener('click', function (event) {
      var btn = event.target.closest('.code-container');
      if (!btn) return;

      var code = btn.getAttribute('data-code');
      var hint = btn.querySelector('[data-hint]');

      function showCopied() {
        hint.textContent = 'Copied!';
        setTimeout(function () { hint.textContent = 'Click to copy'; }, 2000);
      }

      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(code).then(showCopied, function () {
          fallbackCopy(code, showCopied);
        });
      } else {
        fallbackCopy(code, showCopied);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-media-motion"] && !Shopify.designMode) return;
  try {
    (function () {
    function log() {
      console.log.apply(console, ['[rotation]'].concat(Array.prototype.slice.call(arguments)));
    }

    function initRotation() {
      var root = document.querySelector('product-info');
      if (!root) return log('STOP: product-info not found');

      log('section id:', root.id);

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        return log('STOP: reduced motion is turned on');
      }

      var gallery = root.querySelector('media-gallery');
      if (!gallery) return log('STOP: media-gallery element not found');

      var buttons = Array.prototype.slice.call(
        gallery.querySelectorAll('.thumbnail-list .thumbnail')
      );
      log('thumbnails found:', buttons.length);
      if (!buttons.length) return log('STOP: no thumbnail strip rendered. Set Layout to Thumbnail carousel.');
      if (buttons.length < 2) return log('STOP: need at least 2 thumbnails');

      var paused = false;
      var visible = true;
      var timer = null;
      var pausedUntil = 0;
      var INTERVAL = 2000;

      function currentIndex() {
        for (var i = 0; i < buttons.length; i++) {
          if (buttons[i].getAttribute('aria-current') === 'true') return i;
        }
        return 0;
      }

      function next() {
        if (paused || !visible || document.hidden || Date.now() < pausedUntil) return;
        var target = (currentIndex() + 1) % buttons.length;
        log('switching to thumbnail', target);
        buttons[target].click();
      }

      function start() {
        if (timer) clearInterval(timer);
        timer = setInterval(next, INTERVAL);
      }

      // Rotate only when the gallery is fully on screen. The gallery scrolls
      // the page to any slide that is partly out of view, so this check keeps
      // that scroll from happening.
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          visible = entries[0].intersectionRatio >= 0.95;
        }, { threshold: [0, 0.95, 1] }).observe(gallery);
      }

      // Pause rotation for a few seconds after any scroll so it doesn't
      // compete with the user
      window.addEventListener('scroll', function () {
        pausedUntil = Date.now() + 3000;
      }, { passive: true });

      var wrapper = root.querySelector('.product__media-wrapper');
      if (wrapper) {
        wrapper.addEventListener('mouseenter', function () { paused = true; });
        wrapper.addEventListener('mouseleave', function () { paused = false; });
      }

      // A manual thumbnail click restarts the timer
      buttons.forEach(function (b) { b.addEventListener('click', start); });

      start();
      log('rotation started');
    }

    function waitForGallery() {
      if (window.customElements && customElements.get('media-gallery')) {
        initRotation();
      } else if (window.customElements) {
        customElements.whenDefined('media-gallery').then(initRotation);
      } else {
        setTimeout(waitForGallery, 200);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', waitForGallery);
    } else {
      waitForGallery();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
